(function () {
  "use strict";

  function buildOverlay() {
    if (document.getElementById("nire-image-viewer")) return;
    const overlay = document.createElement("div");
    overlay.id = "nire-image-viewer";
    overlay.innerHTML =
      '<img id="nire-image-viewer-img" alt="" />' +
      '<button type="button" id="nire-image-viewer-close" aria-label="Close">&times;</button>';
    document.body.appendChild(overlay);

    overlay.addEventListener("click", function (e) {
      if (e.target.id !== "nire-image-viewer-img") close();
    });
    document
      .getElementById("nire-image-viewer-close")
      .addEventListener("click", close);
  }

  function open(src, alt) {
    const overlay = document.getElementById("nire-image-viewer");
    const img = document.getElementById("nire-image-viewer-img");
    if (!overlay || !img) return;
    img.src = src;
    img.alt = alt || "";
    overlay.classList.add("active");
    document.body.classList.add("nire-image-viewer-open");
  }

  function close() {
    const overlay = document.getElementById("nire-image-viewer");
    if (!overlay) return;
    overlay.classList.remove("active");
    document.body.classList.remove("nire-image-viewer-open");
    const img = document.getElementById("nire-image-viewer-img");
    if (img) setTimeout(function () { if (!overlay.classList.contains("active")) img.src = ""; }, 200);
  }

  function attachListeners() {
    const containers = document.querySelectorAll(".wiki-content, .from-markdown, .web-page-content");
    containers.forEach(function (container) {
      container.querySelectorAll("img").forEach(function (img) {
        if (img.dataset.nireViewerBound) return;
        if (img.closest("a")) return;
        img.dataset.nireViewerBound = "true";
        img.style.cursor = "zoom-in";
        img.addEventListener("click", function (e) {
          e.preventDefault();
          open(img.src, img.alt);
        });
      });
    });
  }

  function init() {
    buildOverlay();
    attachListeners();

    document.addEventListener("keydown", function (e) {
      const overlay = document.getElementById("nire-image-viewer");
      if (e.key === "Escape" && overlay && overlay.classList.contains("active")) close();
    });

    const targets = document.querySelectorAll(".wiki-content, .from-markdown, .web-page-content");
    targets.forEach(function (target) {
      new MutationObserver(attachListeners).observe(target, {
        childList: true,
        subtree: true,
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
